const SET_SOLAR_SYSTEM_SIZE = 'SET_SOLAR_SYSTEM_SIZE';
const SET_SOLAR_PRODUCTION_RATIO = 'SET_SOLAR_PRODUCTION_RATIO';
const SET_SOLAR_VALUE = 'SET_SOLAR_VALUE';
const SET_SOLAR_ANNUAL_DEG = 'SET_SOLAR_ANNUAL_DEG';
const SET_SYSTEM_PRICE = 'SET_SYSTEM_PRICE';
const SET_INSTALL_TYPE = 'SET_INSTALL_TYPE';
const SET_INSTALL_TYPE2 = 'SET_INSTALL_TYPE2';
const SET_INVERTER = 'SET_INVERTER';
const SET_SOLAR_PANEL = 'SET_SOLAR_PANEL';
const SET_SYSTEM_NOTES = 'SET_SYSTEM_NOTES';
const SET_SOLAR_INPUTS = 'SET_SOLAR_INPUTS';

export {
    SET_SOLAR_SYSTEM_SIZE,
    SET_SOLAR_PRODUCTION_RATIO,
    SET_SOLAR_VALUE,
    SET_SOLAR_ANNUAL_DEG,
    SET_SYSTEM_PRICE,
    SET_INSTALL_TYPE,
    SET_INSTALL_TYPE2,
    SET_INVERTER,
    SET_SOLAR_PANEL,
    SET_SYSTEM_NOTES,
    SET_SOLAR_INPUTS,
};



// WEBPACK FOOTER //
// ./src/containers/common/solar/constants.js